import { Attribute, Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { BasicPageService } from '@app/services/api/basic-page.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Directive({
    selector: '[extendedRouterLink]',
    standalone: false
})
export class ExtendedRouterLinkDirective extends RouterLink implements OnInit {
  @Input() public set extendedRouterLink(value: string) {
    this._extendedRouterLink = value;

    this.initRouteLink();
  }

  public get extendedRouterLink() {
    return this._extendedRouterLink;
  }

  @Input() public set pageId(value: string) {
    this._pageId = value;

    this.initRouteLink();
  }

  public get pageId() {
    return this._pageId;
  }

  private _pageId: string;
  private isExternalLink = false;
  private isEmailLink = false;
  public url: string;
  private _extendedRouterLink: string;

  private initialized = false;

  constructor(
    router: Router, 
    route: ActivatedRoute, 
    @Attribute('tabindex') tabIndexAttribute: string | null | undefined, 
    renderer: Renderer2, 
    el: ElementRef,
    private readonly pagesService: BasicPageService) {
    super(router, route, tabIndexAttribute, renderer, el);
  }

  ngOnInit(): void {
  this.initialized = true;
    this.initRouteLink();
  }

  private initRouteLink(): void {
    if (!this.initialized) {
      return;
    }
  
    if (this.pageId) {
      this.loadPageAlias().subscribe(alias => {
        this.setRouterLinkAndHref(alias);
      });

      return;
    }

    this.setRouterLinkAndHref(this.extendedRouterLink);
  }

  private loadPageAlias(): Observable<string> {
    if (!this.pageId) {
      return of(null);
    }
  
    return this.pagesService.getPageById(this.pageId)
      .pipe(
        map(page => page.alias)
      );
  }

  private setRouterLinkAndHref(url: string): void {
    if (!url) {
      return;
    }
  
    this.url = decodeURIComponent(url);
    const regex = /https?:\/\/((?:[\w\d-]+\.)+[\w\d]{2,})/i;
    this.isExternalLink = regex.test(this.url);
    this.isEmailLink = /^mailto:/.test(this.url);

    if (!this.isExternalLink && !this.isEmailLink) {
      const linkSplitted = url.split('?');
      this.routerLink = linkSplitted[0];
      if (linkSplitted.length > 1) {
        const params = linkSplitted[1].split('&');
        this.queryParams = params.reduce((all, current) => {
          const splittedCurrent = current.split('=');
          return {
            ...all,
            [splittedCurrent[0]]: splittedCurrent[1]
          };
        }, {});
      }
    }
  }

  public onClick(button: number, ctrlKey: boolean, shiftKey: boolean, altKey: boolean, metaKey: boolean): boolean {
    if (this.isExternalLink || this.isEmailLink) {
      const link = decodeURIComponent(this.url);
      window.open(link, this.isEmailLink ? '_self' : '_blank');
      return false;
    }

    return super.onClick(button, ctrlKey, shiftKey, altKey, metaKey);
  }

}
